import styled from "styled-components";
import tick from "../../../assets/img/icons/tick.svg";

export const MarketplaceFilterWrapper = styled.div`
  & .container {
    & .filter_wrapper {
      display: flex;
      justify-content: space-between;
      @media (max-width: 991.98px) {
        flex-wrap: wrap;
      }
    }
  }
`;

export const MarketplaceFilterMain = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 991.98px) {
    margin-bottom: 20px;
  }
  @media (max-width: 991.98px) {
    overflow-x: scroll;
    height: 400px;
    margin-bottom: -350px;
    align-items: flex-start;
    width: 100%;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
      opacity: 0;
    }
  }
`;

export const MarketplaceFilterButton = styled.button`
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 126.2%;
  margin-right: 25px;
  background: ${(props) => props.theme.bgColor};
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 6px 20px;
  outline: none;
  white-space: nowrap;
  color: ${(props) => props.theme.textColor};
  @media (max-width: 1199.98px) {
    margin-right: 15px;
  }
  & svg {
    margin-right: 10px;
    & path {
      fill: ${(props) => props.theme.textColor};
      stroke: ${(props) => props.theme.textColor};
    }
  }
`;

export const FilterWrapper = styled.div`
  position: relative;
  padding-bottom: 15px;
  @media (max-width: 991.98px) {
    margin-bottom: 0;
  }
`;

export const MarketplaceFilterDropdown = styled.div`
  position: absolute;
  left: 90%;
  top: 45px;
  height: ${(props) => (props.showDropdown ? "160px" : "0")};
  overflow: hidden;
  z-index: 2;
  transition: 0.2s;
  transform: translateX(-50%);
  padding: 0 15px;
  background: ${(props) => props.theme.body};
  box-shadow: 1px 6px 20px rgba(0, 0, 0, 0.22);
  border-radius: 10px;
  width: 220px;
  & h6 {
    display: flex;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: ${(props) => props.theme.textColor};
    align-items: center;
    margin: 15px 0 15px;
    & img {
      width: 28px;
      margin-right: 10px;
    }
  }
`;

export const MarketplaceFilterDropdownCollection = styled(MarketplaceFilterDropdown)`
  height: ${(props) => (props.showDropdown ? "250px" : "0")};
  left: 50%;
`;

export const MarketplaceFilterDropdownCategories = styled(MarketplaceFilterDropdown)`
  height: ${(props) => (props.showDropdown ? "210px" : "0")};
  left: 50%;
`;

export const MarketplaceFilterDropdownSaleType = styled(MarketplaceFilterDropdown)`
  height: ${(props) => (props.showDropdown ? "110px" : "0")};
  left: 50%;
`;

export const MarketplaceFilterDropdownSort = styled(MarketplaceFilterDropdown)`
  height: ${(props) => (props.showDropdown ? "280px" : "0")};
  left: calc(50% - 12px);
  width: 255px;
`;

export const MarketplaceFilterDropdownRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  & input {
    width: 46%;
    background: ${(props) => props.theme.body};
    border: 1px solid ${(props) => props.theme.borderColor};
    border-radius: 5px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.textColor};
    outline: none;
    padding: 7px 10px;
  }
  & button {
    margin-top: 15px;
    width: 46%;
    background: #dadada;
    border-radius: 36px;
    height: 32px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1f1f23;
    border: none;
    outline: none;
    cursor: pointer;
  }
  & button:nth-child(2) {
    background-color: #0088cc;
    color: #fff;
    &:disabled {
      opacity: 0.7;
      background: #dadada;
      color: #1f1f23;
    }
  }
`;

export const MarketplaceFilterSearch = styled.input`
  background: ${(props) => props.theme.bgColor};
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 25px;
  padding: 5px 10px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  display: flex;
  align-items: center;
  width: 100%;
  margin: 15px 0;
`;

export const MarketplaceFilterCol = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 185px;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    width: 3px;
    background: rgba(187, 187, 187, 1);
    border-radius: 4px;
  }
`;

export const MarketplaceFilterCollection = styled.div`
  margin: 5px 0;
  display: flex;
  align-items: center;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: ${(props) => props.theme.textColor};
  & img {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    margin-right: 10px;
    object-fit: cover;
  }
  & span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const CategoriesFilterValue = styled.div`
  margin: 6px 0;
  padding: 6px;
  white-space: nowrap;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  cursor: pointer;
  color: ${(props) => props.theme.textColor};
  background-color: ${(props) => (props.active ? props.theme.hover : "transparent")};
  border-radius: 5px;
  background-image: ${(props) => (props.active ? `url(${tick})` : null)};
  background-size: 20px;
  background-position: 95% center;
  background-repeat: no-repeat;
`;

export const MarketplaceFilterSearchWrapper = styled.div`
  position: relative;
  height: fit-content;
`;

export const MarketplaceFilterSearchInput = styled.input`
  border: none;
  outline: none;
  border-bottom: 1px solid ${(props) => props.theme.borderColor};
  width: 260px;
  padding: 5px 50px 5px 10px;
  background: ${(props) => props.theme.body};
  color: ${(props) => props.theme.textColor};
  @media (max-width: 1199.98px) {
    width: 210px;
  }
  @media (max-width: 991.98px) {
    width: 300px;
  }
`;

export const MarketplaceFilterSearchLogo = styled.button`
  border: none;
  cursor: pointer;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
`;
